import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
//import { debounce as _debounce, random as _random } from 'underscore';

export default class{

    constructor(options) {

        this.defaults = {
        	main 		: undefined,
        	$el 		: [],

        	delay_load  : 777,
        	addHistory 	: false,
        	loadBeforeEnter: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'ajax-load-more-button';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;

		this.$el.data( 'original-text', this.$el.text() );

		this.init( true );
		this.active = false;
    }

    init( b ){
		if ( b ){
			this.$el.addClass( 'no-barba' );
			this.$el.on( 'click', (e)=>this.loadAjaxContent(e) );
		}
		else{
			this.$el.off( 'click', (e)=>this.loadAjaxContent(e) );
		}
    }

	loadAjaxContent( e ){

		e.preventDefault();

		if ( this.active ){
			return;
		}

		this.active = true;
		
		let href 				= this.$el.attr( 'href' ), 
			grid_class 			= '.' + this.$el.attr( 'data-class-target-grid'), 
			grid_item_class 	= '.' + this.$el.attr( 'data-class-item-grid');

		this.setLoading( true );

		$.ajax( href )
		.done( ( data ) =>{
			this.onLoadAjaxContent( href, data, grid_class, grid_item_class );
		})
		.fail( () => {
			console.log( 'Ajax load :: error' );
		})
		.always( ()=> {
			this.setLoading( false );
			this.active = false;
		});

	}


	setLoading( b ){

		if ( b ){
			this.$el.removeClass( 'loaded-ajax' ).addClass( 'loading-ajax' );
			this.$el.text( 'Loading ...' );
		}
		else{
			this.$el.removeClass( 'loading-ajax' ).addClass( 'loaded-ajax' );
			this.$el.text( this.$el.data( 'original-text' ) );
		}

		this.main.setLoading( b );
	}


	onLoadAjaxContent( href, data, grid_class, grid_item_class ){

		//console.log( data );
		//let parser, doc;
    	//parser = new DOMParser();
    	//doc = parser.parseFromString( data, "text/html");
		//this.$el.data( 'title', doc.title );
		//this.$el.data( 'href', href );
		//this.$el.data( 'post_title', $(data).find( '#hidden-page-title' ).html() );
		//parser = doc = null;

		let $grid = $(data).find( grid_class ), $items, $grid_to_append = $( grid_class ), $button;

		if ( $grid.length > 0 ){
			$items = $grid.find( grid_item_class );
			if ( $items.length > 0 ){
				if ( $grid_to_append.hasClass( 'grid-packery' ) ){
					//$grid_to_append.packery( 'appended', $items );

					$grid_to_append.append( $items );
					$grid_to_append.data('widget').appended( $items );
				}
				else{
					$grid_to_append.append( $items );
				}
				// fade in
				gsap.fromTo( $items, {opacity:0}, {opacity:1, duration:0.6, ease: 'power.out'} );
			}
		}

		// if there isn't the load more butoon there are no more items to load
		$button = $(data).find( '.' + this.$el.attr( 'data-class-self' ) );
		if ( $button.length <= 0  ){
			this.$el.addClass( 'loaded-ajax-complete' );
		}
		else{
			// change the url for next load more items 
			this.$el.attr( 'href',  $button.attr( 'href' ) );
		}

		// call-back to main
		//this.main.onLoadAjaxContent( href, this.$el, data, this.options.addHistory );
		
	}


	/*

	setCurrentPage( setFirstPage=false ){
		let history 	= window.history,
			index 		= this.index,
			title 		= this.$el.data('title'),
			post_title 	= this.$el.data('post_title'),
			href 		= this.$el.data('href'),
			origin;

		if ( setFirstPage && index === 0 ){
			origin 		= this.$el.data( 'origin' );
			index 		= -1;
			title 		= origin.title;
			post_title 	= origin.post_title;
			href 		= origin.href;
		}

		if ( history ){
			if ( history.state ){
				if ( history.state.id === index ){
					return;
				}
			}			
		}

		//console.log( 'setCurrentPage, is_first_page = ' +  setFirstPage + ' , title = ' + title );

		this.changeConpactNavTitle( post_title );
		this.changePageTitle( title );
		this.changeHistory( history, index, title, href );

	}

	changeHistory( history, index, title, href ){
		if ( history ){
			history.replaceState( { id: index }, title, href )
		} 				
	}

	*/

    destroy(){
    	this.init( false );
    }

}